export default __webpack_public_path__ + "static/media/Jaimaruthi.c09d13a2.png";